module.exports = __webpack_public_path__ + "img/plus.17db8c9a.svg";